import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FormControl, Tab, Grid, Table } from "@/comn/components";
import { comnEnvs, comnUtils } from "@/comn/utils";
import { Page, Group, Layout, Button, ExcelUpload } from "@/comn/components";
import { lpcoEnvs, lpcoUtils } from "@/tz/go/egaz/osci/lpco/comn";
import {
    useForm,
    useFetch,
    useGrid,
    useResource,
    usePopup,
    useStore,
    useToast,
    useAuth,
    useModal,
    useTab,
    usePage,
} from "@/comn/hooks";
import {
    BASE,
    URLS,
    APIS,
    SF_SCHEMA_STSTCL_SELC,
    SG_STSTCL_SELC_TRDE,
} from "@/tz/go/egaz/osci/ststcl/lpco/service/OsciStstclSelcService";
import { MASK } from "@/tz/go/egaz/osci/lpco/comn/LpcoConstants";
export const OSCI0502004Q = (props: any) => {
    const { pgeUid, menuId } = usePage({
        auth: ["auth_osci0004", "auth_osci0001", "auth_osci0002"],
    });
    const { t } = useTranslation(); // Translation Hook !== 언어 변화 Hook ==!
    const navigate = useNavigate(); // Navigate Hook !== 화면 이동 Hook ==!
    const modal = useModal(); // Modal Window Hook !== Modal 창 Hook ==!
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!
    const auth = useAuth(); // Login , User Information Hook !== 로그인, 유저정보 Hook ==!

    // 전체 조회용 기관(OGAZ0037)이면 OGA 선택 가능 !== ==!
    const isAllOga = auth.get("orgCd") === "OGAZ0037";

    const [orgCdList, setOrgCdList] = useState([]);

    let errmsg: any;

    /*
     * Definition Form
     * !== 폼 정의 ==!
     */
    const form = {
        // Statistics by Search Form !== HSCODE 통계 검색 Form ==!
        ststclSelcSrch: useForm({
            defaultSchema: SF_SCHEMA_STSTCL_SELC,
            defaultValues: {
                ...(pgeStore?.form || {
                    // 전체 조회용 기관(OGAZ0037)은 OGA를 공백으로 두어 전체 조회 !== ==!
                    orgCd: isAllOga ? "" : auth.get("orgCd"),
                    orgNm: isAllOga ? "" : auth.get("orgNm"),
                    srchStrtDt: comnUtils.getDate({ m: -1 }),
                    srchEndDt: comnUtils.getDate(),
                }),
            },
        }),
    };

    /*
     * Definition Grid
     * !== 그리드 정의 ==!
     */
    const grid = {
        rprtList: useGrid({
            defaultSchema: SG_STSTCL_SELC_TRDE,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    const render = {
        grid_rprtList: {
            head: {},
            cell: {
                ucrNo: (props: any) => {
                    const { binding, rowValues, value } = props;
                    return comnUtils.getFormattedValue(rowValues.ucrNo, {
                        type: "text",
                        mask: MASK.UCR_NO,
                    });
                },
                exppn: (props: any) => {
                    const { binding, rowValues, value } = props;
                    if (rowValues.expTin) {
                        return `[${rowValues.expTin}] ${rowValues.expNm}`;
                    } else {
                        return `${rowValues.expNm}`;
                    }
                },
                imppn: (props: any) => {
                    const { binding, rowValues, value } = props;
                    if (rowValues.impTin) {
                        return `[${rowValues.impTin}] ${rowValues.impNm}`;
                    } else {
                        return `${rowValues.impNm}`;
                    }
                },
                tansadNo: (props: any) => {
                    const { binding, rowValues, value } = props;
                    if (rowValues.cstmOfceCd && rowValues.tansadYy && rowValues.tansadSrno) {
                        return `${rowValues.cstmOfceCd}-${rowValues.tansadYy}-${rowValues.tansadSrno}`;
                    }
                },
                appCdNm: (props: any) => {
                    const { binding, rowValues, value } = props;
                    return `${rowValues.appNm}`;
                },
            },
        },
    };

    const fetch = {
        getStstclByTradeList: useFetch({
            api: (page = grid.rprtList.page) => {
                return APIS.getStstclByTradeList(form.ststclSelcSrch.getValues(), page, grid.rprtList.size);
            },
            onSuccess: (data: any) => {
                console.log(data);
                setStore(pgeUid, {
                    form: form.ststclSelcSrch.getValues(),
                    page: grid.rprtList.page,
                    size: data.rprtList.page.totalSize,
                });
            },
            onError: (error) => {
                errmsg =
                    error.response?.data.errorCode == -1
                        ? "msg.osc.00015"
                        : error.response?.data.errorMessage || "msg.osc.00015";

                modal.openModal({
                    content: errmsg,
                });
            },
            showToast: false,
        }),
    };

    const handler = {
        setInit: async () => {
            // !== 기관 목록 ==!
            handler.refreshOrgCdList();
        },
        refreshOrgCdList: async () => {
            setOrgCdList((await lpcoUtils.getOrgCdList()) || []);
        },
        getStstclByTradeList: () => {
            form.ststclSelcSrch.handleSubmit((data) => {
                grid.rprtList.setPage(0);
                fetch.getStstclByTradeList.fetch(0);
            })();
        },
    };

    useEffect(() => {
        handler.setInit();
    }, []);

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control
                                {...form.ststclSelcSrch.schema.orgCd}
                                options={orgCdList}
                                edit={isAllOga}
                            />
                        </Group.Row>
                        <Group.Row>
                            <Group.Label {...form.ststclSelcSrch.schema.srchDtLb} />
                            <Group.Control {...form.ststclSelcSrch.schema.srchDtDvn} controlSize={1}></Group.Control>
                            <Group.Control {...form.ststclSelcSrch.schema.srchDt} controlSize={9}></Group.Control>
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.ststclSelcSrch.schema.srchCntyOrigCd} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.ststclSelcSrch.schema.srchHsCd} />
                            <Group.Control {...form.ststclSelcSrch.schema.srchAppTpCd} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.ststclSelcSrch.schema.srchCstmOfceCd} />
                            <Group.Control {...form.ststclSelcSrch.schema.srchNreglYn} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.ststclSelcSrch.schema.srchLpcoSttsCd} />
                            <Group.Control {...form.ststclSelcSrch.schema.srchTansadSttsCd} />
                        </Group.Row>
                    </Group.Section>

                    <Layout direction="row">
                        <Layout.Left>
                            <Button
                                role="reset"
                                onClick={() => {
                                    form.ststclSelcSrch.reset();
                                }}
                            />
                        </Layout.Left>
                        <Layout.Right>
                            <Button
                                role="search"
                                onClick={() => {
                                    handler.getStstclByTradeList();
                                }}
                            />
                        </Layout.Right>
                    </Layout>
                </Group.Body>
            </Group>

            <Group>
                <Group.Body>
                    <Layout direction="row">
                        <Layout.Left>
                            <Button
                                role="excelDown"
                                onClick={async () => {
                                    if (grid.rprtList.getViewData().length < 1) {
                                        modal.openModal({
                                            content: "msg.osc.00050", // No data found. !== 해당 데이터가 없습니다. ==!
                                        });
                                    } else {
                                        grid.rprtList.exportExcel({
                                            excelName: "Trade information list",
                                            sheetName: "Trade information list ",
                                        });
                                    }
                                }}
                            />
                        </Layout.Left>
                    </Layout>
                    <Group.Section>
                        <Grid
                            {...grid.rprtList.grid}
                            data={fetch.getStstclByTradeList.data?.rprtList}
                            render={render.grid_rprtList}
                        />
                    </Group.Section>
                </Group.Body>
            </Group>
        </Page>
    );
};
